import {createTheme} from '@material-ui/core/styles'

const CustomTheme = createTheme({
    direction: 'rtl',
    typography:{
        fontFamily:'iranYekanRegular',
    },
});

export default CustomTheme;